/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState,useEffect, useCallback, useContext } from 'react';
import CardHeader from "../../../components/CardHeader"
import Table from './Components/Table'
import { useSearchParams } from 'react-router-dom'
import Search from './../TopBarComponents/Search'
import Filter from './../TopBarComponents/Filter'
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { pushOrRemoveElement } from '../../../CommonMethods/pushOrRemoveElement';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from '../../../services/data.services';
import Debounce from '../../../CommonMethods/Debounce';
import Shimmer from '../../../components/Shimmer/itemShimmer'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import EmptyAddScreen from '../../../components/EmptyAddScreen'
import GlobalContext from '../../../components/Context/GloablContext';
import Toast from '../../../components/Toast';
import Loader from '../../../components/Loader';
import moment from 'moment';

const InventoryIssueReport = () => {
    const {setToastmessage, reloadFY, setReloadFY} = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams()
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [finacialYear, setFinacialYear] = useState('')
    const [academicYears, setAcademicYears] = useState('')
    const [InventoryIssueReportList, setInventoryIssueReportList] = useState([])
    const [reportTotal, setReportTotal] = useState('')
    const [issueReportTotal, setIssueReportTotal] = useState('')
    const [InventoryIssueReportCount, setInventoryIssueReportCount] = useState(0)
    const [InventoryIssueReportTotalCount, setInventoryIssueReportTotalCount] = useState(0)
    const [loading, setLoading] =useState(true) 
    const [selectedDateRange, setSelectedDateRange] = useState(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [FilterData, setFilterData] = useState({date_range : [],});
    const [filterCount, setFilterCount] = useState(0)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [exportBtnLoading, setExportBtnLoading] = useState(false)
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const [FYLoading, setFYLoading] = useState(true);
    const placeholderOptions = [
        'Student Name / ID',
        'Item Name / Code',
    ];

    const outSideClick = useRef();

    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    /**
     * The function `exportBtnhandler` calls an API to get data for an inventory issue report export.
     */
    const exportBtnhandler = () => {
        if ( loading || exportBtnLoading) {
            return;
        }
        if (InventoryIssueReportCount === 0) {
            setToastErrorMessage("No records to export");
            return;
        }
        getExportDataForInventoryIssueReportAPICall()
    }
    
    //Fliter Functions----
    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
        };
        // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        setFilterCount(count)
    };
    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)
        } else {
            setFilterCount(0)
        }
    }
    /**
     * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
     * the filter open state.
     */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    filter_val[item] = params[item].split(',')
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : currentFinacialYear)
        setSelectedFilter('date_range')
        setSelectedDateRange(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    }
    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the filter component. When a click is
    detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
    is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
     * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
     * object's id, dateString, and selectedFilter.
     */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }
    /**
     * The function `handleApplyFilter` is used to apply filters to a search query and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type && Object.keys(FilterCheckbox).length !==0) {
            params.main = selectedName
            if (selectedName === 'Custom') {
                if((FilterCheckbox['start_date']!==null && FilterCheckbox['end_date']!==null)){
                    params.dropname = 'Custom';
                } else {
                    setSearchParams({...params})
                }
            } else if (selectedName.includes('FY')) {
                params.dropname = 'Financial Year';
            } else {
                params.dropname = 'Academic Year';
            }

            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    FilterCheckbox[item].map((key) => {
                        val += `${key},`
                    })
                    params[item] = val.slice(0, -1)
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            const searchParam = searchParams.get('search');
            searchParam !== null ? setSearchParams({'search': searchParam}) : setSearchParams({});            
            setSelectedDateRange('Financial Year')
            setSelectedName(currentFinacialYear)
            setFilterCheckBox([])
            setSelectedFilter('date_range')
        }
        getCount(type)
    }

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false)
            
            window.location.reload();
            setReloadFY(false);
        }
    }, [reloadFY]);

    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }

    //----

    //Search Functions ----
    /**
     * The function `handleSearchParams` updates the search parameters by adding or modifying a key-value
     * pair, and then updates the state with the new search parameters.
     */
    const handleSearchParams = (key, value) => {
        console.log(key,value)
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        console.log(params)
        setSearchParams({ ...params })
        
    }
    /* The `optimizedFn` is a memoized version of the `Debounce` function that is used to debounce the
    `handleSearchParams` function. Debouncing is a technique used to limit the number of times a
    function is called by delaying its execution until after a certain amount of time has passed since
    the last time it was invoked. */
    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );
    //----

    //API Calls----
    /**
     * The function `getFinancialYears` retrieves financial years data from an API, sets the financial
     * years state, sets the current financial year state, and updates the search parameters.
     */
    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`;
            const response = await dataService.GetAPI(endpoint, true)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }

    /**
     * The function `getAcademicYears` retrieves ongoing and upcoming academic years from an API based on
     * the branch ID and sets the retrieved data to the state variable `AcademicYears`.
     */
    const getAcademicYears = async() => {
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed`;
        const response = await dataService.GetAPI(endpoint, true)
        const temp = response?.data?.data?.data
        setAcademicYears(temp)
    }

    /* The above code is a JavaScript React function using the `useCallback` hook to make an API call to
    retrieve inventory issue report data. Here is a breakdown of what the code is doing: */
    const getInventoryIssueReportListAPICall = useCallback(async () => {
        if(searchParams?.get('search') === null){
            setsearchFieldDebounce('')
        }
        try {   
            setLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `inventory/issue-report?filter=true&branch_id=${branch_id}&page_number=${
                searchParams?.get('page_number')===null ? '1' : searchParams?.get('page_number')}${
                searchParams?.get('search') === null ? '': `&search=${encodeURIComponent(searchParams?.get('search'))}` }${`${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}${
                searchParams?.get('sort') === null 
                    ? '' 
                    : `&sort=${encodeURIComponent(searchParams.get('sort'))}`
            }`
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.data
            const temp2 = response?.data?.data?.total_count
            const temp3 = response?.data?.data?.all_total_count
            const temp4 = response?.data?.data?.report_total_price
            const temp5 = response?.data?.data?.report_total_issued_quantity
            setInventoryIssueReportList(temp)
            setInventoryIssueReportCount(temp2)
            setInventoryIssueReportTotalCount(temp3)    
            setReportTotal(temp4)
            setIssueReportTotal(temp5)
        } catch(error) {
            console.log(error)
            setLoading(false)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        } finally{
            setLoading(false)
            updateFilterCheckBox();
        }
    }, [searchParams, FYLoading]);

    /**
     * The function `getExportDataForInventoryIssueReportAPICall` makes an API call to retrieve data for
     * Inventory Issue Report and opens a new window with the pre-signed URL for exporting the data.
     */
    const getExportDataForInventoryIssueReportAPICall = async() => {
        try{
            setExportBtnLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `inventory/issue-report?branch_id=${branch_id}&export=true&filter=true${`${
                searchParams?.get('search') === null ? '': `&search=${encodeURIComponent(searchParams?.get('search'))}` }${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}`;
            const response = await dataService.GetAPI(endpoint)
            setToastmessage(response?.data?.data?.message)
            window.open(response?.data?.data?.pre_signed_url)
        } catch(error) {
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            setExportBtnLoading(false)
            console.log(error)
        } finally {
            setExportBtnLoading(false)
        }
    }
    //----

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    /* The below code is using the `useEffect` hook in a React component. It is calling three different API
    functions: `getClassesAPI()`, `getSectionsAPI()`, and `getFinancialYears()`. These functions are
    likely used to fetch data from an API. The `useEffect` hook is used to perform these API calls when
    the component mounts. The empty array `[]` as the second argument to `useEffect` ensures that the
    API calls are only made once, when the component initially mounts. */
    useEffect(()=>{
        getFinancialYears()
        getAcademicYears()
    },[])
        
    /* The below code is using the `useEffect` hook in React to make an API call to
    `getInventoryIssueReportListAPICall` function. This API call is made when the component is mounted
    or when the `getInventoryIssueReportListAPICall` function changes. */
    useEffect(() => {
        if (startDate != null && !FYLoading ){
            getInventoryIssueReportListAPICall()
        }
    }, [searchParams, startDate, FYLoading]);

    return (
        <CardHeader noPadding>
            {/* top bar */}
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky"}}
            >
                <div className="flex items-center">
                    <h5 class=" pageHeader adderror">
                        Inventory Issue Report
                    </h5>
                </div> 
                <div className='flex items-center'>
                    <Search
                        SearchValue={searchFieldDebounce}
                        handleOnClickSearch={setsearchFieldDebounce}
                        optimizedFn={optimizedFn}
                        customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                    />
                    <div class="relative">
                        <button onClick={() => {
                            handleOpenFilter()

                        }} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            filterCount={filterCount}
                            selectedDateRange={selectedDateRange}
                            setSelectedDateRange={setSelectedDateRange}
                            selectedName={selectedName}
                            setSelectedName={setSelectedName}
                            searchParams={searchParams}
                            ref={outSideClick}
                            currentFinacialYear={currentFinacialYear}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}  
                            radioButton={true}   
                            finacialYear={finacialYear}  
                            academicYears={academicYears}
                            setSearchParams={setSearchParams} 
                            setStartDate={setStartDate} 
                            setEndDate={setEndDate}   
                            dateRangeDropdownOptions={[{ name: 'Financial Year' }, {name: 'Academic Year'}, { name: 'Custom' }]}
                            calculateEndDate={calculateEndDate}
                        />}
                    </div>
                    <button onClick={exportBtnhandler} id='export'
                        className={`prmy-btn`}>
                        {exportBtnLoading ? <Loader /> : 'Export'}
                    </button>
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            <div class="mainDataCntnrListDiv scrollBlue_thick">
                { loading 
                    ? <div className='mt-[32px]'><Shimmer/></div>
                    : <Table startDate={startDate} endDate={endDate} reportTotal={reportTotal} issueReportTotal={issueReportTotal} InventoryIssueReportStudentList={InventoryIssueReportList} setPageLoading={setLoading} searchParams={searchParams} setSearchParams={setSearchParams} InventoryIssueReportStudentCount={InventoryIssueReportCount}  handleOnClickSort={handleSearchParams} sortValue={searchParams.get('sort') || ''}/>}
            </div>
        </CardHeader>
    )
}

export default InventoryIssueReport;